import { useQueries } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';
import { PriceHistory, Resolution } from '@toggle/toggle';

import { fetchPrices } from '~/services/price/price-service';

const QUERY_KEY_PRICE_CHANGE_HISTORY = 'QUERY_KEY_PRICE_CHANGE_HISTORY';

interface UsePriceHistoryListProps {
  tags: string[];
  tickers: string[];
  dateFrom: string;
  dateTo: string;
  resolution: Resolution;
  enabled?: boolean;
}

export interface PriceHistoryListItem {
  data: PriceHistory;
  entityTag: string;
}

export interface UsePriceHistoryListResult {
  data: PriceHistoryListItem[];
  isLoading: boolean;
  isError: boolean;
}

export const usePriceHistoryList = ({
  tags,
  tickers,
  dateFrom,
  dateTo,
  resolution,
  enabled = true,
}: UsePriceHistoryListProps): UsePriceHistoryListResult =>
  useQueries({
    queries: tags.map((entityTag, index) => ({
      queryKey: [
        QUERY_KEY_PRICE_CHANGE_HISTORY,
        entityTag,
        tickers[index],
        resolution,
        dateFrom,
        dateTo,
      ],
      queryFn: () =>
        fetchPrices({
          entityTag,
          ticker: tickers[index],
          resolution,
          dateFrom,
          dateTo,
        }),
      staleTime: getTimeTillEndOfDayMs(),
      enabled,
    })),
    combine: (results): UsePriceHistoryListResult => ({
      data: results.flatMap((r, index) =>
        r.data ? [{ data: r.data, entityTag: tags[index] }] : []
      ),
      isLoading: results.some(r => r.isLoading),
      isError: results.every(r => r.isError),
    }),
  });
